export default "__VITE_ASSET__UWHMBYHr__"